import { Sun, Moon, Desktop } from "@phosphor-icons/react";
import { useTheme } from "@/contexts/ThemeContext";

const LABELS = {
  dark: "Scuro",
  light: "Chiaro",
  auto: "Auto",
};

export default function ThemeToggle({ className = "", size = 18 }) {
  const { theme, toggleTheme } = useTheme();
  const nextLabel = theme === "dark" ? LABELS.light : theme === "light" ? LABELS.auto : LABELS.dark;
  const Icon = theme === "dark" ? Moon : theme === "light" ? Sun : Desktop;
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={`Tema ${LABELS[theme]}. Clicca per passare a ${nextLabel}`}
      title={`Tema: ${LABELS[theme]} — clicca per ${nextLabel}`}
      className={`theme-toggle-btn ${className}`}
      data-testid="theme-toggle"
      data-theme-mode={theme}
    >
      <Icon size={size} weight="fill" />
    </button>
  );
}
